export const REGEX_LIB = {
  onlyNumbers: new RegExp('^[0-9]*$'),
  phoneNumber: new RegExp('^[0-9]{5,15}$'),
}
